import { render } from "./OrderGeneralInfo.vue?vue&type=template&id=74581cdf&scoped=true"
import script from "./OrderGeneralInfo.vue?vue&type=script&lang=js"
export * from "./OrderGeneralInfo.vue?vue&type=script&lang=js"

import "./OrderGeneralInfo.vue?vue&type=style&index=0&id=74581cdf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74581cdf"]])

export default __exports__